import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "test" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "TEST", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tests, (test, k) => {
      return (_openBlock(), _createElementBlock("div", { key: k }, _toDisplayString(test.message), 1))
    }), 128)),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        class: "m-4 border border-blue-500",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.message) = $event))
      }, null, 512), [
        [_vModelText, _ctx.formValue.message]
      ]),
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addMessage && _ctx.addMessage(...args)))
      }, "追加")
    ])
  ]))
}